<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="displayHeaders" :items="items" :options.sync="options" :server-items-length="totalItems"
        :loading="loading" loading-text="Cargando..." class="elevation-1" item-key="id" :footer-props="footerOptions">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <back-button></back-button>
            <v-toolbar-title v-html="title"></v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-on:input="debounceInput" label="Buscar" single-line hide-details />
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small :color="themeColor" @click="openModalTransfer(item)" v-on="on">
                <v-icon>mdi-swap-horizontal</v-icon>
              </v-btn>
            </template>
            <span>Transferir</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">{{ showLicenceStatus(item) }}</template>
        <template v-slot:item.device_id="{ item }">
          <span v-if="item.device_id">{{ item.device }}</span>
          <span v-else>No Asignada</span>
        </template>
        <template v-slot:item.enterprise_id="{ item }">
          <span v-if="item.enterprise_id">{{ item.enterprise }}</span>
          <span v-else>No Asignada</span>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label>
          <br />
          <v-btn :color="themeColor" @click="reset">Limpiar búsqueda</v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog v-model="dialogShowTransfer" max-width="800">
      <v-card>
        <v-card-title class="headline">
          Realizar Transferencia
        </v-card-title>
        <v-container>
          <v-form ref="formTransfer" v-model="transferFormValid" lazy-validation @submit.prevent="onTransferFormSubmit"
            @keydown="form.onKeydown($event)">
            <v-row>
              <v-col cols="9" v-if="this.item">
                <v-card-text>
                  <v-text-field v-model="item.codigo" label="Licencia a transferir" maxlength="8" readonly
                    hide-details />
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="9">
                <v-card-text v-if="this.item">
                  <v-text-field v-model="form.account_ruc_dealer" label="No. Cuenta o Ruc del Distribuidor"
                    maxlength="150" :rules="transferFieldRules" required @input="verifyAccountsDealer" />
                </v-card-text>
              </v-col>
              <v-col cols="3">
                <v-tooltip bottom v-if="this.item">
                  <template v-slot:activator="{ on }">
                    <v-btn :color="themeColor" @click="searchDealerAccount" v-on="on" :loading="searching || form.busy">
                      <v-icon text>
                        mdi-credit-card-search
                      </v-icon>
                    </v-btn>
                  </template>
                  Buscar Distribuidor
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row v-if="this.item">
              <v-col cols="4">
                <v-card-text>
                  <v-text-field v-model="dealer.razonSocial" label="Razón Social" placeholder="Distribuidor S.A."
                    readonly />
                </v-card-text>
              </v-col>
              <v-col cols="4">
                <v-card-text>
                  <v-text-field v-model="dealer.ruc" label="RUC" placeholder="155596713-2-2015" readonly />
                </v-card-text>
              </v-col>
              <v-col cols="4">
                <v-card-text>
                  <v-text-field v-model="dealer.account_number" label="No. Cuenta"
                    placeholder="CE6842F4-15CE-49FB-8F76-AFDA292202B9" readonly />
                </v-card-text>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error darken-1" text @click="closeDialogTransfer">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text :loading="form.busy" :disabled="disabledAcceptTransaccion"
            @click.prevent="generateMovement()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmTransfer" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline">
          Confirmar transferencia
        </v-card-title>
        <v-card-text class="pt-2">
          ¿Está seguro que desea transferir la licencia con código:
          <strong>{{ item.codigo }}</strong>
          al distribuidor (<strong>{{ dealer.razonSocial }}</strong>)?
          Tenga en cuenta que esta transacción es irreversible.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error darken-1" text :disabled="form.busy" @click="cancelConfirmTransfer">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text :loading="form.busy" @click="executeTransferAfterConfirm">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import * as _ from 'underscore';
import Form from 'vform';
import BackButton from '~/components/BackButton';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('services') };
  },
  props: {
    id: { default: '' },
    action: { default: '' },
    queryParams: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    loading: false,
    editedIndex: -1,
    options: {},
    search: '',
    items: [],
    item: {},
    name: '',
    tipo: '',
    totalItems: 0,
    footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
    toggleStatus: false,
    message: '',
    headers: [
      {
        text: 'Código',
        value: 'codigo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Dispositivo',
        value: 'device_id',
        sortable: false,
      },
      {
        text: 'Empresa',
        value: 'enterprise_id',
        sortable: false,
      },
      {
        text: 'Estatus',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Acciones',
        value: 'actions',
        sortable: false,
      },
    ],
    disabledAcceptTransaccion: false,
    dialogShowTransfer: false,
    dialogConfirmTransfer: false,
    searching: false,
    dealer: {
      ruc: '',
      razonSocial: '',
      account_number: '',
      incoming_account_id: '',
    },
    form: new Form({
      id_licencia: '',
      type_movement: '3',
      service_id: '',
      incoming_account_id: '',
      dealer_id: '',
      account_ruc_dealer: '',
      busy: false,
    }),
    transferFormValid: true,
    transferRules: {
      required: (v) => (!!v && String(v).trim().length > 0) || 'El campo es requerido.',
      maxAccount: (v) => !v || String(v).length <= 150 || 'Máximo 150 caracteres.',
    },
  }),
  computed: {
    transferFieldRules() {
      return [this.transferRules.required, this.transferRules.maxAccount];
    },
    apiURL() {
      return `/api/catalogs/dealers/${this.user.dealer_id}/licences/${this.id}`;
    },
    title() {
      return `Códigos de Licencia de <b>${this.name}</b>`;
    },
    displayHeaders() {
      if (this.tipo === 'ILIMITADAS') {
        return this.headers;
      }
      return this.headers.filter((h) => h.value !== 'actions');
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },
  components: {
    BackButton,
  },

  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    apiURL: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    queryParams: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
  mounted() {
    window.axios
      .get(`/api/catalogs/services/${this.id}`)
      .then((result) => {
        this.name = result.data.nombre;
        this.tipo = result.data.tipo;
      });
  },
  methods: {
    onTransferFormSubmit() {
      // Evita envío nativo del formulario; Aceptar usa generateMovement.
    },
    debounceInput: _.debounce(function d(e) {
      this.search = e;
    }, 500),
    verifyAccountsDealer() {
      if (this.form.account_ruc_dealer === this.item.account_number) {
        this.$store.dispatch('notifications/show', {
          message: 'No puede colocar su numero de cuenta para realizar una transferencia.',
          type: '#ffc107',
        });
        this.form.account_ruc_dealer = '';
      }
    },
    generateMovement() {
      if (!this.$refs.formTransfer || !this.$refs.formTransfer.validate()) {
        return;
      }
      if (!this.dealer.incoming_account_id) {
        this.$store.dispatch('notifications/show', {
          message: 'Busque y confirme el distribuidor destino antes de aceptar.',
          type: 'error',
        });
        return;
      }
      this.dialogShowTransfer = false;
      this.$nextTick(() => {
        this.dialogConfirmTransfer = true;
      });
    },
    cancelConfirmTransfer() {
      this.dialogConfirmTransfer = false;
      this.resetForm();
      this.item = {};
    },
    executeTransferAfterConfirm() {
      this.dialogConfirmTransfer = false;
      this.form.busy = true;
      const url = '/api/catalogs/services/licences/transfer';
      window.axios
        .post(url, {
          id_licencia: this.item.id,
          codigo_licencia: this.item.codigo,
          id_servicio: this.item.service_id,
          id_distribuidor_actual: this.item.dealer_id,
          id_distribuidor_nuevo: this.dealer.incoming_account_id,
          ruc_distribuidor_nuevo: this.dealer.ruc,
          no_cuenta_distribuidor_nuevo: this.dealer.account_number,
          rz_distribuidor_nuevo: this.dealer.razonSocial,
        })
        .then((response) => {
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          if (response.data.type === 'success') {
            this.resetForm();
            this.item = {};
            this.dialogShowTransfer = false;
            this.refreshTable();
          }
        })
        .catch(() => {
          this.$store.dispatch('notifications/show', {
            message: 'Error al transferir la licencia.',
            type: 'error',
          });
        })
        .finally(() => {
          this.form.busy = false;
        });
    },
    resetForm() {
      this.form.account_ruc_dealer = '';
      this.dealer = {
        ruc: '',
        razonSocial: '',
        account_number: '',
        incoming_account_id: '',
      };
      this.$nextTick(() => {
        if (this.$refs.formTransfer) {
          this.$refs.formTransfer.resetValidation();
        }
      });
    },
    searchDealerAccount() {
      if (this.form.account_ruc_dealer) {
        this.searching = true;
        const url = `/api/getAccount/${this.form.account_ruc_dealer}`;
        window.axios.get(url)
          .then((response) => {
            if (response.data.type === 'success') {
              this.dealer.ruc = response.data.item.identificacion;
              this.dealer.razonSocial = response.data.item.razonSocial;
              this.dealer.account_number = response.data.item.account_number;
              this.dealer.incoming_account_id = response.data.item.id;
              this.disabledAcceptTransaccion = false;
            }
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.searching = false;
          });
      } else {
        this.$store.dispatch('notifications/show', {
          message: 'Introduzca un número de identificación.',
          type: 'error',
        });
      }
    },
    showLicenceStatus(item) {
      let message = 'Asignable a: ';
      if (item.device_id === null) { message += 'Dispositivo, '; }
      if (item.dealer_id === null && item.enterprise_id === null) { message += 'Distribuidor, '; }
      if (item.enterprise_id === null) { message += 'Empresa.'; }
      return message;
    },
    refreshTable() {
      this.getDataFromApi().then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
      });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise(async (resolve) => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage,
        } = this.options;
        const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
          const data = response.data.items;
          const { total } = response.data;
          return ({ data, total } || []);
        });
        const items = response.data;
        const { total } = response;

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
      &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    openModalDelete(item) {
      this.$refs.delete.openModal(item);
    },
    reset() {
      this.search = '';
    },
    openModalTransfer(item) {
      this.item = item;
      this.form.account_ruc_dealer = '';
      this.dealer = {
        ruc: '',
        razonSocial: '',
        account_number: '',
        incoming_account_id: '',
      };
      this.dialogShowTransfer = true;
      this.$nextTick(() => {
        if (this.$refs.formTransfer) {
          this.$refs.formTransfer.resetValidation();
        }
      });
    },
    closeDialogTransfer() {
      this.dialogShowTransfer = false;
      this.dialogConfirmTransfer = false;
      this.resetForm();
      this.item = {};
    },
  },
};
</script>
